import { z } from 'zod';

/** Argo CD が監視するリポジトリの Zod スキーマ */
export const ArgoCDWatchTargetSchema = z.object({
  repository_name: z.string().nullable(),
  repo_url: z.string().nullable(),
  target_revision: z.string().nullable(),
  manifest_path: z.string().nullable(),
});

/**
 * GET /api/workspace/{orch_workspace_id}/runtimeenvs/{runtime_id}/orch-runtime-details
 * レスポンスの Zod スキーマ
 */
export const OrchRuntimeDetailsResponseSchema = z.object({
  runtime_name: z.string(),
  saas_service_domain: z.string().nullable(),
  resource_group_name: z.string().nullable(),
  created_at: z.string().nullable(),
  subscription_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  service_account: z.string().nullable(),
  runtime_cicd_paths: z.array(z.string()),
  argocd_watch_targets: z.array(ArgoCDWatchTargetSchema),
  argocd_application_url: z.string().nullable(),
  azure_kubernetes_service_name: z.string(),
  namespace: z.string().nullable(),
});

/** orch-runtime-details API レスポンスの型 */
export type OrchRuntimeDetailsResponse = z.infer<
  typeof OrchRuntimeDetailsResponseSchema
>;
